var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "app_detail_azure"
  }, [_c('div', {
    staticClass: "a_col"
  }, [_c('span', {
    staticClass: "lable"
  }, [_vm._v($t("4b4u0k6", "密钥到期时间"))]), _c('span', [_vm._v(_vm._s(_vm.expireAt))])]), _c('div', {
    staticClass: "a_col"
  }, [_c('span', {
    staticClass: "lable"
  }, [_vm._v($t("detknv4", "更新密钥"))]), _c('DatePicker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "options": _vm.options,
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": $t("4b4u0k6", "密钥到期时间")
    },
    on: {
      "on-change": _vm.setTime
    }
  }), _c('Button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.refreshToken
    }
  }, [_vm._v($t("fua43o4", "立即更新"))])], 1), _c('div', {
    staticClass: "a_col"
  }, [_c('span', {
    staticClass: "lable"
  }, [_vm._v($t("gfbz2", "密钥"))]), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.token) + " ")]), _vm.token ? _c('span', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: _vm.token,
      expression: "token",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: _vm.onCopy,
      expression: "onCopy",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: _vm.onError,
      expression: "onError",
      arg: "error"
    }],
    staticClass: "copy"
  }, [_vm._v($t("fljd2", "复制"))]) : _vm._e(), _vm.hideToken() ? _c('Icon', {
    attrs: {
      "size": "20",
      "type": "md-eye-off"
    },
    on: {
      "click": function ($event) {
        return _vm.showToken(true);
      }
    }
  }) : _c('Icon', {
    attrs: {
      "size": "20",
      "type": "md-eye"
    },
    on: {
      "click": function ($event) {
        return _vm.showToken(false);
      }
    }
  })], 1)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };